// extracted by mini-css-extract-plugin
export default {"ring":"Loading_ring__D9M82","animateC":"Loading_animateC__j9JU1","spanRing":"Loading_spanRing__6CFsP","animate":"Loading_animate__pc9zw"};